import type React from "react";
import { formatPokemonDisplayName } from "../utils/pokemonFormatter";

interface PokemonGridProps {
  pokemon: string[];
  selectedPokemon: string | null;
  setSelectedPokemon: (pokemon: string | null) => void;
  showShiny?: boolean;
}

function PokemonGrid({
  pokemon,
  selectedPokemon,
  setSelectedPokemon,
  showShiny = false,
}: PokemonGridProps): React.JSX.Element {
  const handlePokemonClick = (pokemonName: string): void => {
    setSelectedPokemon(pokemonName);
  };

  const getImagePath = (pokemonName: string): string => {
    // Use static directory structure for clean UI
    const directory = showShiny ? 'shiny' : 'base';
    return `/pokemon/static/${directory}/${pokemonName}.png`;
  };


  return (
    <div className="pokemon-grid">
      {pokemon.map((pokemonName) => (
        <button
          key={pokemonName}
          type="button"
          className={selectedPokemon === pokemonName ? 'pokemon-grid-item-selected' : 'pokemon-grid-item'}
          onClick={() => handlePokemonClick(pokemonName)}
        >
          <img
            src={getImagePath(pokemonName)}
            alt={pokemonName}
            loading="lazy"
            className="pokemon-grid-sprite"
          />
          <div className="pokemon-grid-name">
            {formatPokemonDisplayName(pokemonName)}
          </div>
        </button>
      ))}
    </div>
  );
}

export default PokemonGrid;
